import { render, staticRenderFns } from "./editorInput.vue?vue&type=template&id=2ba0fee0&scoped=true"
import script from "./editorInput.vue?vue&type=script&lang=js"
export * from "./editorInput.vue?vue&type=script&lang=js"
import style0 from "./editorInput.vue?vue&type=style&index=0&id=2ba0fee0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba0fee0",
  null
  
)

export default component.exports